<template>
    <section
        :id="`element-${settings.id}`"
        ref="$gallery"
        class="elle-locations-hero f-screen"
        data-is-hero
        :style="{ backgroundColor: settings?.color }"
    >
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline :settings="{ label: settings.label, headline: settings.headline }">
                        <template #additional>
                            <div v-if="settings?.linksUrls.length" class="buttons">
                                <UiLink
                                    v-for="(link, index) in settings?.linksUrls"
                                    :key="index"
                                    :link="link"
                                    :style="'transparent-border w-border'"
                                />
                            </div>
                        </template>
                    </UiHeadline>
                </div>
                <div class="m-col">
                    <div v-if="settings?.body" class="content typography" v-html="props.settings?.body" />
                </div>
                <div class="r-col">
                    <LazyUiScrolledGallery v-if="!!settings?.gallery.length" :images="settings?.gallery" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
